export default {
  "title": "FreeDive Ai",
  "heroHeadline": "Train every day and improve your freediving skills!",
  "heroSubheadline": "The ultimate AI apnea training app for freedivers, spearfishers, and mermaids.",
  "featuresHeader": "Why Choose FreeDive Ai?",
  "featuresSubtitle": "Everything you need to dive deeper, hold your breath longer, and stay safe.",
  "feature1Title": "AI Apnea Training",
  "feature1Desc": "Customized CO2 and O2 tables generated by AI based on your personal bests to safely increase your breath-hold times.",
  "feature2Title": "Smart Logbook",
  "feature2Desc": "Log your freediving and spearfishing sessions. Track depths, times, heart rate, and SpO2 all in one place.",
  "feature3Title": "Competitions & Licenses",
  "feature3Desc": "Keep track of your freediving licenses and stay updated with global competitions and events.",
  "screenshotsTitle": "App Screenshots",
  "copyright": "© DomiLabs. All rights reserved."
};
